import React, { useMemo } from "react";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import { MatchResult } from "../../../../Entities/MatchResult";
import JobApplicationProfileMatchResultItem from "./JobApplicationProfileMatchResultItem";
import { MatchFilterType } from "./JobApplicationProfileMatchResult";

interface JobApplicationProfileMatchResultDetailsProps {
  jobPost: JobDescriptionEntity;
  profileMatchResult: MatchResult;
  activeFilter: MatchFilterType;
}

const JobApplicationProfileMatchResultDetails: React.FC<
  JobApplicationProfileMatchResultDetailsProps
> = ({ jobPost, profileMatchResult, activeFilter }) => {
  const jobPostRequirements = jobPost.requirements || [];

  const formattedProfileMatchResult = useMemo(() => {
    return profileMatchResult.results
      .map((result) => {
        const requirement = jobPostRequirements.find(
          (req) => req.id === result.requirement_id
        );

        if (!requirement) return null;

        const status =
          result.match_status === 1
            ? "matched"
            : result.match_status === 0
            ? "unmatched"
            : result.match_status === -1
            ? "partial"
            : "unknown";

        return {
          topic: requirement.topic,
          description: requirement.description,
          aiResponse: result?.reason,
          status: status,
        };
      })
      .filter(
        (
          item
        ): item is {
          topic: string;
          description: string;
          aiResponse: string;
          status: "matched" | "unmatched" | "partial";
        } => item !== null
      );
  }, [profileMatchResult.results, jobPostRequirements]);

  const filteredResults = useMemo(() => {
    if (activeFilter === 'all') {
      return formattedProfileMatchResult;
    }
    return formattedProfileMatchResult.filter(
      (result) => result.status === activeFilter
    );
  }, [formattedProfileMatchResult, activeFilter]);

  return (
    <div className="job-application-profile-match-result-items-list-container">
      {filteredResults.map((result, index) => (
        <JobApplicationProfileMatchResultItem
          key={index}
          topic={result.topic}
          description={result.description}
          aiResponse={result.aiResponse}
          status={result.status}
        />
      ))}
    </div>
  );
};

export default JobApplicationProfileMatchResultDetails;
